module.exports = __webpack_public_path__ + "img/logo-400x400.e9af429d.png";